import Handlebars from '@sparta.global.vendors/handlebars';
import sanitizeStructuredData from '@sparta.global.utilities/sanitize-structured-data/dist/es5.js';

/**
 * printStructuredData documentation
 * @param {object} data a structuredData object
 * @returns {object} Handlebars SafeString
 */
function printStructuredData(data) {
  var structuredData = sanitizeStructuredData(data);
  return new Handlebars.SafeString(structuredData);
}
export { printStructuredData };